import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const AbnormalBadge2: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-destructive bg-transparent text-destructive">
      {t('component:badge.abnormal')}
    </Badge>
  );
};
